import { Services, supportedReportTypes } from '@sigma-frontend-libs/commons'

import { labelModes, permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Type',

  mixins: [ proxy() ],

  props: {
    required: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },

    labelMode: {
      type: String,
      default: labelModes.line,
      validator: value => {
        return Object.values(labelModes).includes(value)
      }
    },

    showError: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    filteredItems() {
      return supportedReportTypes.filter(value => {
        return this.checkPermissions(`advanced.${Services['report-manager']}.reports.${value}`, permissionPresets.meUp)
      })
    },
    items() {
      return this.filteredItems.map(value => {
        return {
          title: this.getTranslate(`${Services['report-manager']}.types.${value}`),
          value
        }
      })
    }
  },

  render
}

